/**
 * Footer component.
 * @module components/theme/Footer/Footer
 */

import React from 'react';
import { Container, List, Segment, Grid, GridColumn, Icon, Image } from 'semantic-ui-react';
import map from 'lodash/map';
import { FormattedMessage, defineMessages, injectIntl } from 'react-intl';
import { useSelector, shallowEqual } from 'react-redux';
import UniversalLink from '@plone/volto/components/manage/UniversalLink/UniversalLink';
import { flattenToAppURL, addAppURL } from '@plone/volto/helpers/Url/Url';
import Logo_descr from '../../../../images/ASDR_Logo.png';

const messages = defineMessages({
  copyright: {
    id: 'Copyright',
    defaultMessage: 'Copyright',
  },
});

/**
 * Component to display the footer.
 * @function Footer
 * @param {Object} intl Intl object
 * @returns {string} Markup of the component
 */
const Footer = ({ intl }) => {
  const { siteActions = [] } = useSelector(
    (state) => ({
      siteActions: state.actions?.actions?.site_actions,
    }),
    shallowEqual,
  );

  return (
    <Segment
      role="contentinfo"
      vertical
      padded
      inverted
      textAlign="center"
      id="footer"
    >
      <Container>
        <Grid textAlign="left" columns={2}>
          <Grid.Column>
            <Image
	      id="footer_logo"
	      src={Logo_descr}
	      alt="Naturgefahrentagung"
	      title="Naturgefahrentagung"
	      height={72}
	    />
          </Grid.Column>
          <Grid.Column>
	     <span></span>
          </Grid.Column>
        </Grid>
      </Container>
    </Segment>
  );
};


/**
 * Property types.
 * @property {Object} propTypes Property types.
 * @static
 */
Footer.propTypes = {
  /**
   * i18n object
   */
};

export default injectIntl(Footer);
